import Vue from 'vue'
import Router from 'vue-router'

import Unicorn from './Privacy'
import Agreement from "./Agreement"
Vue.use(Router)

export default new Router({

  routes: [
    {
      path:'/',
      name:'unicorn',
      component:Unicorn
    },
    {
      path:'/agreement',
      name:'agreement',
      component:Agreement
    }
  ],
   scrollBehavior(to,from,savedPosition){
      if(savedPosition){
        return savedPosition;
      }else{
        return {x:0,y:0}
      }
    }
})
